const side_image_element = document.getElementById("side_image_element");

const questionImageMap = {
    "685d77c5c72c6b615ceba68d": "https://file.tangent.ai/quiz-content/merchants/000705-c1/image/4475193633653094-Your%20curated%20skincare%20starts%20here%20(1).jpg",
    "685d77c5c72c6b615ceba68f": "https://file.tangent.ai/quiz-content/merchants/000705-c1/image/6067869968100263-3%20(1)%20(1).jpg",
    "685d77c5c72c6b615ceba693": "https://file.tangent.ai/quiz-content/merchants/000705-c1/image/6254358331768564-5%20(1).jpg",
    "685d77c5c72c6b615ceba699": "https://file.tangent.ai/quiz-content/merchants/000705-c1/image/015458054952735-6%20(1).jpg",
    "685d77c5c72c6b615ceba6a3": "https://file.tangent.ai/quiz-content/merchants/000705-c1/image/2024610289013895-4%20(1).jpg",
    "6860df4ec72c6b615ceca6ae": "https://file.tangent.ai/quiz-content/merchants/000705-c1/image/01641385897303249-What%20do%20you%20value%20most..%20(1).jpg",
    "6860df97c72c6b615ceca6e1": "https://file.tangent.ai/quiz-content/merchants/000705-c1/image/10880770989014188-When%20it%20comes%20to%20ingredients_%20(1).jpg",
    "685d77c5c72c6b615ceba6a9": "https://file.tangent.ai/quiz-content/merchants/000705-c1/image/6110583760245101-2%20(1).jpg",
    "685d77c5c72c6b615ceba6ab": "https://file.tangent.ai/quiz-content/merchants/000705-c1/image/6110583760245101-2%20(1).jpg"
}

function updateProgressBar(present, total) {
    let progressBar = document.getElementById("progress-bar");
    if (present != 0 && present != 1) {
        progressBar.style.width = ((present - 2) / (total - 1)) * 100 + "%";
    }
}
function addQuestionDots(count) {
    const dotsContainer = document.getElementById("dots-container");
    for (let i = 0; i < count; i++) {
        let dot = document.createElement("div");
        dot.classList.add("dots");
        if (i == 0) {
            dot.classList.add("dots-active");
        }
        dot.innerHTML = "&nbsp;";
        dotsContainer.appendChild(dot);
    }
}

// Function to update active dot based on present question number
function updateActiveDot(present) {
    const dotElements = document.getElementsByClassName("dots");
    for (let i = 0; i < dotElements.length; i++) {
        if (i <= present - 2) {
            setTimeout(() => {
                dotElements[i].classList.add("dots-active");
            }, 150);
        } else {
            dotElements[i].classList.remove("dots-active");
        }
    }
}

function updateSideImage(data) {
    const questionId = data[3];
    side_image_element.src = questionImageMap[questionId];
}

window.addEventListener("quiz_progress", (event) => {
    let progressData = event.detail.split("_");
    let presentQuestion = Number(progressData[0]); //current question index
    let totalQuestion = Number(progressData[1]) - 2; // total number of questions

    let progressBar = document.getElementById("progress-bar-block");
    let quiz = document.getElementById("tangent-main-container");
    let image = document.getElementById("image-container");

    updateProgressBar(presentQuestion, totalQuestion);
    progressBar.style.display = "block";
    image.style.display = "block";
    if (presentQuestion == "0" || presentQuestion == "1" || presentQuestion == "8") {
        progressBar.style.display = "none";
    }

    updateSideImage(progressData);
    // Check if dots are already added, otherwise add them
    let dotElement = document.getElementsByClassName("dots");
    if (dotElement.length == 0) {
        addQuestionDots(totalQuestion);
    }
    // Update active dot based on the present question
    updateActiveDot(presentQuestion);
});